/**
 * ---------------------------------------------------------------------------
 * In-button loading state
 * ---------------------------------------------------------------------------
 * Two cases, both of which previously gave the shopper no usable feedback:
 *
 *   1. Product page "Add to cart" — theme.js disables the button while the
 *      AJAX add runs, and the store's `.button[disabled] { display:none }`
 *      customisation made it vanish outright.
 *
 *   2. Cart page "Checkout" — a plain form submit. Nothing happens visually
 *      while the browser navigates to Shopify's checkout, which on a slow
 *      connection reads as a dead button and invites a second click.
 *
 * We drive a `.is-loading` class; button-loading.css does the rest.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var LOADING = 'is-loading';
  // Safety net: never leave a button stuck if an event we rely on goes missing.
  var MAX_MS = 12000;
  var timers = new WeakMap();

  function start(button) {
    if (!button || button.classList.contains(LOADING)) {
      return;
    }

    button.classList.add(LOADING);
    clearTimeout(timers.get(button));
    timers.set(button, setTimeout(function () {
      stop(button);
    }, MAX_MS));
  }

  function stop(button) {
    if (!button) {
      return;
    }

    button.classList.remove(LOADING);
    clearTimeout(timers.get(button));
    timers.delete(button);
  }

  function stopAll() {
    var loading = document.querySelectorAll('.' + LOADING);

    for (var i = 0; i < loading.length; i++) {
      stop(loading[i]);
    }
  }

  /* -------------------------------------------------------------------------
   * 1. Add to cart
   * ---------------------------------------------------------------------- */

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) {
        return;
      }

      var addButton = event.target.closest('[data-action="add-to-cart"]');

      if (addButton && !addButton.disabled) {
        start(addButton);
      }
    },
    true // capture, so we run before theme.js disables the button
  );

  // theme.js fires this when the add request settles, success or failure.
  document.addEventListener('theme:loading:end', stopAll);
  // Belt and braces: the cart also announces the added product.
  document.documentElement.addEventListener('product:added', stopAll);

  /* -------------------------------------------------------------------------
   * 2. Checkout
   * ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) {
      return;
    }

    var checkoutButton = event.target.closest('button[name="checkout"]');

    if (!checkoutButton || checkoutButton.disabled) {
      return;
    }

    // The page is about to navigate, so this state simply rides out until
    // unload. No timeout clear here would leave it spinning if the shopper
    // comes back, which pageshow below handles.
    start(checkoutButton);
  });

  // Returning via the back button serves a cached page; clear any state that
  // was mid-flight when the shopper left.
  window.addEventListener('pageshow', stopAll);
})();
